import Immutable from 'immutable';

class VehicleValidator {
    static validate(value) {
        let result = new Immutable.Map();
        let errors = new Immutable.List();
        const regex = /^\d{5}$/;
        result = result.set('isValid', true);

        if (!value) {
            errors = errors.insert(errors.count(), 'Vehicle number can\'t be empty');
            result = result.set('isValid', false);
        }

        if (!regex.test(value)) {
            errors = errors.insert(errors.count(), 'Vehicle number must contain 5 characters');
            result = result.set('isValid', false);
        }

        result = result.set('errors', errors);

        return result;

    }

}

export default VehicleValidator;



// WEBPACK FOOTER //
// ./src/utils/VehicleValidator.js